const priorityMap = {
  Refused: 1,
  Pending: 2,
  waiting_document: 2,
  waiting_new_document: 2,
  waiting_check: 2,
  waiting_race_setup: 2,
  creating_expected_attachments: 3,
  no_attachment_expected: 3,
  completed_on_site: 3,
  'In progress': 3,
  Cancelled: 4,
  cancelled: 4,
  'Not verified': 5,
  not_imported: 5,
  verOxfam: 6,
  Verified: 6,
};

export function getHighPriorityDocumentStatus(statuses = []) {
  if (!statuses || statuses.length === 0) {
    return 'Not verified';
  }

  return statuses
    .filter(status => typeof status === 'string')
    .map(status => status.trim())
    .reduce((highestPriorityStatus, status) => {
      const priority = priorityMap[status];
      return priority && priority < priorityMap[highestPriorityStatus]
        ? status
        : highestPriorityStatus;
    }, 'Verified');
}
